export default __webpack_public_path__ + "static/media/honesty2Img5.7fa0ab75.png";